import { getLocalTimeZone, today } from "@internationalized/date";
import { z } from "zod/v4";
import { nuqsBoolean, nuqsCommaArray } from "#/modules/util.pagination/search.nuqs";

/**
 * Search params schema for sociaalresultaten (results) filters: date range, progress flags, domein filter.
 */
export const sociaalresultatenSearchSchema = z.object({
  from: z.string().nullable().default(null),
  to: z.string().nullable().default(null),
  includeWithProgress: nuqsBoolean(true),
  includeWithoutProgress: nuqsBoolean(true),
  selectedDomeinFilterIds: nuqsCommaArray,
});

/** Default values for sociaalresultaten search params; values not explicitly set will be omitted from URL. */
export type SociaalresultatenSearch = z.infer<typeof sociaalresultatenSearchSchema>;

export const SOCIAALRESULTATEN_SEARCH_DEFAULTS: Pick<
  SociaalresultatenSearch,
  "from" | "to" | "includeWithProgress" | "includeWithoutProgress" | "selectedDomeinFilterIds"
> = {
  from: null,
  to: null,
  includeWithProgress: true,
  includeWithoutProgress: true,
  selectedDomeinFilterIds: [],
};

/** Unchanged from the deleted `filters.student.sociaalresultaten.ts` (byte-identical logic). */
export function getDefaultDateRange() {
  const todayDate = today(getLocalTimeZone());
  const startOfYear = todayDate.set({ month: 1, day: 1 });
  const endOfYear = todayDate.set({ month: 12, day: 31 });
  return {
    from: startOfYear.toString(),
    to: endOfYear.toString(),
  };
}
